export default __webpack_public_path__ + "static/media/Glodani 6.3bd4e38c.jpg";